import { Box } from "@chakra-ui/react";

export default function MobileBottomSpacer({
  height = 64, // match your island height
  gap = 16,
}: { height?: number; gap?: number }) {
  return (
    <Box
      aria-hidden
      display={{ base: "block", md: "none" }}
      height={`calc(${height}px + ${gap}px + env(safe-area-inset-bottom))`}
    />
  );
}
